<div
	class="container"
	#matIconContainer
	(click)="clicked($event, false)"
	(keydown.enter)="clicked($event, true)"
	(focus)="setFocusStatus(true)"
	(blur)="setFocusStatus(false)"
	tabindex="{{ disabled() ? -1 : 0 }}"
	[matTooltipDisabled]="disabled() || isToolTipDisabled"
	[matTooltipShowDelay]="375"
	matTooltipPosition="above"
	[matTooltip]="tooltip | translate"
>
	<mat-icon class="container__icon" [class.container__icon--disabled]="disabled()" svgIcon="cancel_button"> </mat-icon>
</div>
